import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, FormBuilder } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SharedModule } from './shared.module';
import { AppComponent } from './app.component';
import { routing, appRoutingProviders } from './app.route';
import { Notifications } from './common/components/notifications.component';
import { PageNotFoundComponent } from './common/components/pagenotfound.component';
// Services
import { HttpClient } from './common/services/http.service';
import { NotificationService, Notification } from './common/services/notifications.service';
import { Constants } from './constants';
import { TRANSLATION_PROVIDERS, TranslateService } from '../translate';
import { GlobalErrorHandler } from './core/global-error-handler/global-error-handler.service';
import { LogService } from './core/log/log.service';
import { RouteInterceptorService } from './core/http/routeInterceptor.service';
// import { MaterialModule } from './material.module';
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    SharedModule,
    routing,
    //MaterialModule,
  ],
  declarations: [
    AppComponent,
    Notifications,
    PageNotFoundComponent
  ],
  providers: [
    Constants,
    TRANSLATION_PROVIDERS,
    TranslateService,
    appRoutingProviders,
    HttpClient,
    NotificationService,
    LogService,
    RouteInterceptorService,
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler
    // },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}